import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.math.sign.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import jwtDecode from 'jwt-decode';
import { mapActions } from 'vuex';
import { isValidToken } from '~/helpers/connection-helper';
import { convertInMinutes, calculateDifferenceInMinutes } from '~/helpers/refresh-auth-helper';
import USE_MERCURE from '~/const/mercure';
import { updateUserToken, refreshToken } from '~/services/user';
var HOURS_TOKEN_MUST_BE_REFRESHED = 2;
var HOURS_TOKEN_IS_VALID = 24;
var HOURS_TOKEN_NEEDS_REFRESH = HOURS_TOKEN_IS_VALID - HOURS_TOKEN_MUST_BE_REFRESHED; // @TODO remove

var styles = ['background: linear-gradient(#D33106, #571402)', 'color: white', 'font-weight: bold', 'padding: 10px'].join(';');
export default {
  data: function data() {
    return {
      source: 'MERCURE',
      ready: true
    };
  },
  created: function created() {
    if (this.$route.name === 'market-language-cart') {
      this.ready = false;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.initRefreshUserToken();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  computed: {
    decodedToken: function decodedToken() {
      return jwtDecode(window.localStorage.getItem('MDM_ACCESS_TOKEN'));
    },
    audience: function audience() {
      var aud = this.decodedToken.aud;
      return Array.isArray(aud) && aud.includes('sts') ? 'sts' : aud;
    },
    isMercureToken: function isMercureToken() {
      return this.audience === 'mercure';
    },
    isStsToken: function isStsToken() {
      return this.audience === 'sts';
    },
    isMercureMarket: function isMercureMarket() {
      return USE_MERCURE(this.locale.iso);
    },
    isSeller: function isSeller() {
      return this.$cookies.get('MDM_SELLER_TOKEN');
    },
    canRenewMercureToken: function canRenewMercureToken() {
      return isValidToken() && !this.isSeller && this.isMercureMarket && this.isMercureToken && this.isTokenAlmostExpired;
    },
    canRefreshStsToken: function canRefreshStsToken() {
      return !this.isSeller && this.isStsToken && this.isMercureMarket && this.isTokenAlmostExpired;
    },
    isTokenAlmostExpired: function isTokenAlmostExpired() {
      var decoded = this.decodedToken;
      var tokenExpiresAt = Number(decoded.exp * 1000);
      var currentTimestamp = new Date().getTime();
      var differenceInMinute = calculateDifferenceInMinutes(tokenExpiresAt, currentTimestamp);
      var minutesBeforeExpiry = Math.sign(differenceInMinute) === 1 ? differenceInMinute : 0; // return minutesBeforeExpiry <= convertInMinutes(HOURS_TOKEN_NEEDS_REFRESH);

      var expiryThreshold = this.$cookies.get('refreshTokenThreshold') || convertInMinutes(HOURS_TOKEN_NEEDS_REFRESH); // @TODO remove

      var debugSts = !!this.$cookies.get('debugSts');

      if (debugSts) {
        console.log('%c Token status', styles);
        console.table({
          'cookie refreshTokenThreshold': this.$cookies.get('refreshTokenThreshold'),
          audience: Array.isArray(decoded.aud) ? decoded.aud.join(', ') : decoded.aud,
          expiryThreshold: expiryThreshold,
          minutesBeforeExpiry: minutesBeforeExpiry,
          expireAt: new Date(decoded.exp * 1000),
          isTokenAlmostExpired: minutesBeforeExpiry <= expiryThreshold
        });
      }

      return minutesBeforeExpiry <= expiryThreshold;
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions({
    setSeller: 'seller/setSeller'
  })), {}, {
    initRefreshUserToken: function initRefreshUserToken() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var seller;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this2.$route.name === 'redirect_url')) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (!(window.localStorage.getItem('MDM_ACCESS_TOKEN') && _this2.canRenewMercureToken)) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 5;
                return _this2.renewCustomerToken();

              case 5:
                _context2.next = 8;
                break;

              case 7:
                if (window.localStorage.getItem('MDM_ACCESS_TOKEN') && _this2.isMercureToken && !isValidToken()) {
                  // delete expiry Mercure accessToken
                  window.localStorage.removeItem('MDM_ACCESS_TOKEN');
                  window.localStorage.removeItem('MDM_ACCESS_TOKEN_EXPIRES_AT');
                }

              case 8:
                if (_this2.isSeller) {
                  seller = jwtDecode(_this2.$cookies.get('MDM_SELLER_TOKEN'));

                  _this2.setSeller(seller);
                }

                if (!(window.localStorage.getItem('MDM_ACCESS_TOKEN') && _this2.canRefreshStsToken)) {
                  _context2.next = 13;
                  break;
                }

                _this2.source = 'STS';
                _context2.next = 13;
                return _this2.renewCustomerToken();

              case 13:
                _this2.ready = true;

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    setCustomerToken: function setCustomerToken(token) {
      var decoded = jwtDecode(token);
      window.localStorage.setItem('MDM_ACCESS_TOKEN', token);
      window.localStorage.setItem('MDM_ACCESS_TOKEN_EXPIRES_AT', decoded.exp * 1000);
    },
    renewCustomerToken: function renewCustomerToken() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var data, token, debugSts;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                data = null;
                token = null;

                if (!(_this3.source === 'STS')) {
                  _context3.next = 10;
                  break;
                }

                _context3.next = 6;
                return refreshToken(_this3.$store);

              case 6:
                data = _context3.sent;
                token = data && data.refreshToken && data.refreshToken.token;
                _context3.next = 14;
                break;

              case 10:
                _context3.next = 12;
                return updateUserToken(_this3.$store);

              case 12:
                data = _context3.sent;
                token = data && data.updateUserToken && data.updateUserToken.token;

              case 14:
                // @TODO remove
                debugSts = !!_this3.$cookies.get('debugSts');

                if (debugSts) {
                  console.log("%c refreshToken ".concat(_this3.source), styles);
                  console.log(token);
                }

                if (token) {
                  _context3.next = 18;
                  break;
                }

                throw new Error("MDM_REFRESH_TOKEN_EMPTY ".concat(_this3.source));

              case 18:
                _context3.next = 20;
                return _this3.setCustomerToken(token);

              case 20:
                _this3.loadUser(); // page need to be refresh


                _context3.next = 26;
                break;

              case 23:
                _context3.prev = 23;
                _context3.t0 = _context3["catch"](0);

                _this3.$logger.customFilter(_context3.t0, "MDM_REFRESH_TOKEN ".concat(_this3.source));

              case 26:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 23]]);
      }))();
    }
  })
};